import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Sidebar from './components/Sidebar';

// New pages
import Home from './pages/Home';
import ThePerson from './pages/ThePerson';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Travel from './pages/Travel';
import TripDetail from './pages/TripDetail';
import Career from './pages/Career';
import CareerDetail from './pages/CareerDetail';
import Blog from './pages/Blog';
import Connect from './pages/Connect';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const main = document.querySelector('.main-content');
    if (main) main.scrollTop = 0;
  }, [pathname]);
  return null;
}

function Layout() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div className="site-layout">
      <ScrollToTop />
      <Sidebar />
      <main
        className="main-content page-fade-in"
        key={location.pathname}
        style={{ paddingTop: isMobile ? '52px' : '0' }}
      >
        <Routes>
          <Route path="/"                element={<Home />} />
          <Route path="/the-person"      element={<ThePerson />} />
          <Route path="/projects"        element={<Projects />} />
          <Route path="/projects/:slug"  element={<ProjectDetail />} />
          <Route path="/travel"          element={<Travel />} />
          <Route path="/travel/:slug"    element={<TripDetail />} />
          <Route path="/career"          element={<Career />} />
          <Route path="/career/:slug"    element={<CareerDetail />} />
          <Route path="/blog"            element={<Blog />} />
          <Route path="/connect"         element={<Connect />} />
        </Routes>
      </main>
    </div>
  );
}

export default Layout;
